var indexOf = require('./indexOf');

    /**
     * If array contains values.
     */
    function contains(arr, val) {
        return indexOf(arr, val) !== -1;
    }
    module.exports = contains;




//////////////////
// WEBPACK FOOTER
// ./~/mout/array/contains.js
// module id = 155
// module chunks = 0 1 2